import React from "react";

const SearchLabelsSkeleton = () => {
  return (
    <>
      <section className="overflow-x-auto snap-x snap-mandatory scrollbar-hidden bg-white px-[16px] py-[8px] md:px-[20px] lg:overflow-hidden xl:px-0 z-[3]">
        <div className="max-w-container mx-auto">
          <ul className="flex items-start gap-[8px]">
            {Array.from({ length: 6 }).map((_, index) => (
              <li key={index} className="min-w-[100px]">
                <span className="skeleton skeleton-text-animated !rounded-[4px] min-h-[24px] flex !m-0"></span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default SearchLabelsSkeleton;
